import { createReducer } from "@reduxjs/toolkit";
import {
  DAM_TYPES_GET_ALL,
  DAM_TYPES_GET_BY_ID,
  DAM_TYPES_ADD,
  DAM_TYPES_UPDATE,
  DAM_TYPES_DELETE,
} from "./action";
import { DamType } from "src/types/damType";

export type DamTypeState = {
  damTypes: DamType[];
  selectedDamType: DamType | null;
};
export const initialState: DamTypeState = {
  damTypes: [],
  selectedDamType: null,
};

const damTypeReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(DAM_TYPES_GET_ALL, (state, action) => {
      state.damTypes = action.payload.damTypes;
    })
    .addCase(DAM_TYPES_GET_BY_ID, (state, action) => {
      state.selectedDamType = action.payload.damType;
    })
    .addCase(DAM_TYPES_ADD, (state, action) => {
      state.damTypes.push(action.payload.damType);
    })
    .addCase(DAM_TYPES_UPDATE, (state, action) => {
      const updated = action.payload.damType;
      state.damTypes = state.damTypes.map((t) =>
        t.damTypeId === updated.damTypeId ? updated : t
      );
    })
    .addCase(DAM_TYPES_DELETE, (state, action) => {
      state.damTypes = state.damTypes.filter(
        (t) => t.damTypeId !== action.payload.damTypeId
      );
    })
);

export default damTypeReducer;